module.exports = __webpack_public_path__ + "static/media/face-template.28eda351.png";